import { PayloadAction, createSlice } from '@reduxjs/toolkit';

import { DiagonalCornerState } from './diagonalCorner.types';

import { DiagonalCornerModel } from '~/core/models';

const initialState: DiagonalCornerState = {
  selectedDiagonalCorner: undefined,
};

export const diagonalCornerSlice = createSlice({
  name: 'diagonalCorner',
  initialState,
  reducers: {
    updateSelectedDiagonalCorner: (
      state,
      action: PayloadAction<DiagonalCornerModel>
    ) => {
      state.selectedDiagonalCorner = action.payload;
    },
    resetSelectedDiagonalCorner: (state) => {
      state.selectedDiagonalCorner = initialState.selectedDiagonalCorner;
    },
  },
});

export default diagonalCornerSlice.reducer;

export const { resetSelectedDiagonalCorner, updateSelectedDiagonalCorner } =
  diagonalCornerSlice.actions;
